function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.333496 6.99967C0.333496 3.32034 3.32016 0.333008 7.00016 0.333008C10.6868 0.333008 13.6668 3.32034 13.6668 6.99967C13.6668 10.6803 10.6868 13.6663 7.00016 13.6663C3.32016 13.6663 0.333496 10.6803 0.333496 6.99967ZM6.4135 4.47302C6.4135 4.15369 6.68016 3.88636 7.00016 3.88636C7.32016 3.88636 7.58016 4.15369 7.58016 4.47302V7.41969C7.58016 7.74036 7.32016 7.99969 7.00016 7.99969C6.68016 7.99969 6.4135 7.74036 6.4135 7.41969V4.47302ZM7.00683 10.1203C6.68016 10.1203 6.42016 9.85366 6.42016 9.53366C6.42016 9.21367 6.68016 8.95366 7.00016 8.95366C7.32683 8.95366 7.58683 9.21367 7.58683 9.53366C7.58683 9.85366 7.32683 10.1203 7.00683 10.1203Z",
  fill: "#D5D5D5"
});
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.f55d6e0d282bb31f241d7cd66a9901a3.svg";
export { ForwardRef as ReactComponent };